var map = {
	"./damage_high.png": 29229,
	"./damage_low.png": 88410,
	"./damage_medium.png": 36556,
	"./flower_cyan.png": 81680,
	"./flower_poppy.png": 44471,
	"./flower_rose.png": 68506,
	"./iron_golem.png": 38205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22769;